export const searchFieldTexts = {
  SEARCH_PLACEHOLDER_TEXT: 'Search',
};
